import { Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Tooltip } from '@/components/floating/Tooltip';
import { CarePlanDirectives } from '@/models/CarePlanDirectivesModel.ts';
import {
  TelemonitoringTier,
  getTelemonitoringTierTranslation,
} from '@/models/CarePlanModel';
import { TeleMonitoringCriteria } from '@/models/TelemonitoringCriteriaModel';

import { ChipSelect } from '../atoms/ChipSelect';

type TelemonitoringTierChipProps = {
  carePlanDirectives: CarePlanDirectives;
};
export const TelemonitoringTierChip = ({
  carePlanDirectives,
}: TelemonitoringTierChipProps) => {
  const context = useFormContext();
  const { t } = useTranslation();

  const telemonitoringCriteria: TeleMonitoringCriteria | undefined =
    context.watch('inclusionCriteria');
  const insulinType = context.watch('insulinScheme');

  if (!telemonitoringCriteria || !insulinType) {
    return null;
  }

  const tier =
    carePlanDirectives.telemonitoringTierMap[
      telemonitoringCriteria as TeleMonitoringCriteria
    ];

  const tooltipTranslationKey: Record<TelemonitoringTier, string> = {
    base: 'diabetesForms.criteriaMeaningBase',
    level1: 'diabetesForms.criteriaMeaningLevel1',
    level2: 'diabetesForms.criteriaMeaningLevel2',
  };

  return (
    <Tooltip
      content={<Typography>{t(tooltipTranslationKey[tier])}</Typography>}
      placement="top"
    >
      <ChipSelect
        id="tls-tier-chips"
        selected={false}
        label={t(getTelemonitoringTierTranslation(tier))}
      />
    </Tooltip>
  );
};
